import { buildOrigin } from './helpers';

export const API_BASE_URL = buildOrigin();

export const REQUEST_FAILED = 'request_failed';

export const IMPERSONATION_EXPIRED = 'Impersonation_Expired';

export const DEFAULT_STATUS_CODE = 0;

export const HTTP_STATUS = {
	Unauthorized: 401,
};

export const API_DATE_FORMAT = 'MM-DD-YYYY';
export const API_DATE_FORMAT_WITH_TIME = 'YYYY-MM-DDTHH:mm:ss';
export const API_DATE_FORMAT_WITH_TIME_UTC = 'YYYY-MM-DD HH:mm';
export const API_DATE_FORMAT_WITH_DATE_TIME_UTC = 'YYYY-MM-DD HH:mm:ss';



// WEBPACK FOOTER //
// ./src/config/api.js